var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block relative"},[_c('i',{staticClass:"spinning-loader fas fa-circle-notch text-green-300 text-3xl"})])}]

export { render, staticRenderFns }